import React, { useEffect } from 'react'
import fetch from '../../uitls/fetch'
import BannerItem, { BannerStyleTypes } from './BannerItem'

interface BannerResultProp {
  id: number
  title: string
  label_names: BannerStyleTypes[]
  body: string
}

interface BannerDataProps {
  count: number
  articles: BannerResultProp[]
}

export const parseBannerStyle = (styles: string[]): BannerStyleTypes => {
  const possibleLabels = ['alert_info', 'alert_danger', 'alert_warning', 'alert_success']

  // order of labels in payload is alphabetical, we dont know if label will be on first or second place.
  // filter the array and extract correct label based on possibleLabels
  const correctStyleExtracted = styles.filter((style: string): BannerStyleTypes => {
    return possibleLabels.includes(style) as unknown as BannerStyleTypes
  })[0]

  // provide fallback for wrong data regarding banner style
  const fallbackStyle = 'alert_info' as BannerStyleTypes
  return (correctStyleExtracted as BannerStyleTypes) || fallbackStyle
}


const NotificationBanner = () => {
  const [bannerData, setBannerData] = React.useState<BannerDataProps>({
    count: 0,
    articles: [],
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/php/advanced_ajax_handler.php?type=zendesk_notifications')
        const jsonBody = await response.json()

        if (jsonBody.length > 0 && jsonBody[0].response) {
          setBannerData(jsonBody[0].response)
        }
      } catch (err) {
        console.log('error: ', err)
      }
    }

    fetchData()
  }, [])

  if (bannerData.count === 0) {
    return null
  }

  return (
    <>
      {bannerData && bannerData.articles
        ? bannerData.articles.map((bannerItem: BannerResultProp) => (
            <BannerItem
              key={bannerItem.id}
              bannerStyle={parseBannerStyle(bannerItem.label_names)}
              title={bannerItem.title}
              message={bannerItem.body}
            />
          ))
        : null}
    </>
  )
}

export default NotificationBanner
